import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ObservacionServicio } from '../model/observacion-servicio';
import { Proveedor } from '../model/proveedor';

const API_OBSERVACIONES = '/Services/Observaciones';
const API_OBSERVACIONES_APROBACION = '/Services/ObservacionesAprobacion';

@Injectable()
export class ObservacionesSolicitudService {

  idsolicitud: number;

  constructor(
    private http: HttpClient
  ) { }

  addObservaciones(solicitudId: number, observaciones: string, interna: boolean, idUsuario: number, esAprobacion: boolean): Observable<number> {
    const obs = new ObservacionServicio();
    obs.ID_SOLICITUD_SERVICIO = solicitudId;
    obs.TEXTO = observaciones;
    obs.INTERNO = interna;
    obs.ID_USER = idUsuario ? idUsuario : null;
    obs.EsAprobacion = esAprobacion;
    return this.http.post<number>(environment.API_BASE + API_OBSERVACIONES, obs);
  }

  getAllObservaciones(solicitudId: number): Observable<ObservacionServicio[]> {
    return this.http.get<ObservacionServicio[]>(environment.API_BASE + API_OBSERVACIONES + '/' + solicitudId)
      .pipe(map(response => response.map(respon => ObservacionServicio.toModel(JSON.stringify(respon)))));
  }

  getAllObservacionesAprobacion(solicitudId: number): Observable<ObservacionServicio[]> {
    return this.http.get<ObservacionServicio[]>(environment.API_BASE + API_OBSERVACIONES_APROBACION + '/' + solicitudId)
      .pipe(map(response => response.map(respon => ObservacionServicio.toModel(JSON.stringify(respon)))));
  }

}
